import axios from 'axios';
import _ from 'underscore';
import lodash from 'lodash';
import { v4 as uuidv4 } from 'uuid';
import { parseStringToDate } from './components/common/date_time';

import { fields, addToExternalData } from './components/update/form_util.js';
import { stringLanguage, newString } from './mock_tranlsations.js';
import { mapDetailsForSurveySubmission, mapComponentNameToImage } from './helpers/siteSurveyDataMapper.js';

const base_path = (process.env && process.env.NODE_ENV == 'test') ?
  'http://localhost' : '';

export const LOGOUT = 'LOGOUT';
export const USER_ROLE_RECEIVED = 'USER_ROLE_RECEIVED';
export const COMPANY_LIST_RECEIVED = 'COMPANY_LIST_RECEIVED';
export const CHANGE_LANGUAGE = 'CHANGE_LANGUAGE';
export const LIST_LANGUAGES = 'LIST_LANGUAGES';
export const ADD_ACTIVE_PAGE = 'ADD_ACTIVE_PAGE';
export const STORE_KEN_NUMBER = 'STORE_KEN_NUMBER';
export const STORE_SO_NUMBER = 'STORE_SO_NUMBER';
export const RECEIVE_APP_PROPS = 'RECEIVE_APP_PROPS';
export const EQUIPMENT_IOT_DATA_RECEIVED = 'EQUIPMENT_IOT_DATA_RECEIVED';
export const EQUIPMENT_IOT_DATA_LOADING = 'EQUIPMENT_IOT_DATA_LOADING';
export const EQUIPMENT_IOT_DATA_ERROR = 'EQUIPMENT_IOT_DATA_ERROR';
export const RESET_IOT_DATA = 'RESET_IOT_DATA';
export const ADD_KEN_LINK = 'ADD_KEN_LINK';
export const REMOVE_KEN_LINK = 'REMOVE_KEN_LINK';
export const REMOVE_ALL = 'REMOVE_ALL';
export const ADD_FLOW = 'ADD_FLOW';
export const UPDATE_COLLECTED_DATA = 'UPDATE_COLLECTED_DATA';
export const FORM_UPLOAD_FAILED = 'FORM_UPLOAD_FAILED';
export const ADD_CANCELLATION_TOKEN = 'ADD_CANCELLATION_TOKEN';
export const REMOVE_CANCELLATION_TOKEN = 'REMOVE_CANCELLATION_TOKEN';
export const SET_IMAGE_UPLOAD_STATUS = 'SET_IMAGE_UPLOAD_STATUS';
export const SELECT_CLINICA_FORM = 'SELECT_CLINICA_FORM';
export const ADD_SURVEY_ID = 'ADD_SURVEY_ID';
export const INIT_LOGGED_IN = 'INIT_LOGGED_IN';
export const EMAIL_SEND_STATUS = 'EMAIL_SEND_STATUS';
export const PDF_GEN_STATUS = 'PDF_GEN_STATUS';
export const STORE_CSRF_TOKEN = 'STORE_CSRF_TOKEN';
export const SYSTEM_DOWNTIME_NOTIFICATION = 'SYSTEM_DOWNTIME_NOTIFICATION';
export const SYSTEM_DOWNTIME_NOTIFICATION_SEEN = 'SYSTEM_DOWNTIME_NOTIFICATION_SEEN';
export const SELECT_SITE_SURVEY_FORM = 'SELECT_SITE_SURVEY_FORM';
export const DISPLAY_SITE_SURVEY_BANNER = 'DISPLAY_SITE_SURVEY_BANNER';
export const DISPLAY_SITE_SURVEY_ALERT = 'DISPLAY_SITE_SURVEY_ALERT';
export const INTERNET_STATUS = 'INTERNET_STATUS';
export const PENDING_TO_START_SURVEY = 'PENDING_TO_START_SURVEY';
export const PREVIOUS_SITE_SURVEY_DATA_LOADING = 'PREVIOUS_SITE_SURVEY_DATA_LOADING';
export const PREVIOUS_SITE_SURVEY_DATA_ERROR = 'PREVIOUS_SITE_SURVEY_DATA_ERROR';
export const PREVIOUS_SITE_SURVEY_DATA_RECEIVED = 'PREVIOUS_SITE_SURVEY_DATA_RECEIVED';

/* ----------------------------------------------------------------------------
APP
--------------------------------------------------------------------------- */

export function setInternetStatus(internetStatus) {
  return function (dispatch) {
    dispatch({
      type: INTERNET_STATUS,
      payload: internetStatus
    });
  }
}

export function startIncompleteSurvey(KEN, countryCode, serviceOrder) {
  return axios
    .post(base_path + `/api/incompleteSurvey`, {
      ken: KEN,
      countryCode: countryCode,
      serviceOrder: serviceOrder,
    })
    .then((res) => {
    })
    .catch((err) => {
      if(err.code === axios.AxiosError.ERR_NETWORK){
        throw new Error(err.code);
      } 
      throw "Start survey status upadate failed";
    });
}

export function setPendingToStartSurvey(surveyStarted) {
  return function (dispatch) {
    dispatch({
      type: PENDING_TO_START_SURVEY,
      payload: surveyStarted,
    });
  };
}

export function setDisplaySiteSurveyBanner(displayBanner) {
  return function (dispatch) {
    dispatch({
      type: DISPLAY_SITE_SURVEY_BANNER,
      payload: displayBanner
    });
  }
}

export function setDisplaySiteSurveyAlert(displayAlert) {
  return function (dispatch) {
    dispatch({
      type: DISPLAY_SITE_SURVEY_ALERT,
      payload: displayAlert
    });
  }
}

export function setSystemDowntimeNotificationSeen(id){

  return function (dispatch) {
    dispatch({
      type: SYSTEM_DOWNTIME_NOTIFICATION_SEEN,
      payload: id
    });
  }
}

export function fetchSystemDowntimeNotification(lang){
  return function (dispatch) {
    return axios.get(base_path + `/api/system_downtime?lang=${lang}`)
      .then((res) => {
        let newNotifications = res?.data
        if (localStorage.getItem('systemDowntimeNotification')){
          // Get notification messages from local storage
          let oldNotifications = JSON.parse(localStorage.getItem('systemDowntimeNotification'))
          newNotifications.map((n , idx)=>{
            // Verify if notification with same id can already be found from local storage
            const oldN = oldNotifications.find(o => o.id === n.id)
            if(Boolean(oldN)){
              // Verify if this message has been changed. Id might be the same but if content has changed we should still show the notification
              if(!lodash.isEqual(lodash.omit(oldN, ['seen', 'seenDate', 'message']),
                  lodash.omit(n, ['seen', 'seenDate', 'message']))){
                delete n.seen
                delete n.seenDate
              // If notification content has not been changed we add old notification object for dispatcher
              // seenDate will be converted to Date if found, otherwise will be null
              }else{
                newNotifications[idx] = oldN
                newNotifications[idx].seenDate = parseStringToDate(newNotifications[idx].seenDate)
              }
            }
          })
        }
        if(newNotifications){
          dispatch({
            type: SYSTEM_DOWNTIME_NOTIFICATION,
            payload: newNotifications
          });
        }
      })
      .catch((err) => {
        console.error(err)
        /* dispatch({
          type: SYSTEM_DOWNTIME_NOTIFICATION,
          payload: undefined
        }); */
        throw "System notification fetch failed"
      })
  }
}

export function selectClinicaForm(value) {
  return {
    type: SELECT_CLINICA_FORM,
    payload: value
  }
}

export function selectSiteSurveyForm(value) {
  return {
    type: SELECT_SITE_SURVEY_FORM,
    payload: value
  }
}

export function storeKENNumber(value) {
  return {
    type: STORE_KEN_NUMBER,
    payload: value
  }
}

export function storeSONumber(value) {
  return {
    type: STORE_SO_NUMBER,
    payload: value
  }
}

export function updateCollectedData(data) {
  return {
    type: UPDATE_COLLECTED_DATA,
    payload: data
  }
}

export function storeSurveyId(payload) {
  return {
    type: ADD_SURVEY_ID,
    payload: payload
  }
}

export function formUploadFailed(what) {
  return {
    type: FORM_UPLOAD_FAILED,
    payload: what
  }
}

export function removeAll() {
  return {
    type: REMOVE_ALL
  }
}

export function receiveKenLink(value) {
  return {
    type: ADD_KEN_LINK,
    payload: value
  }
}

export function removeKenLink() {
  return {
    type: REMOVE_KEN_LINK
  }
}

export function addCancellationToken(formName, fieldName, token, imageId){
  return {
    type: ADD_CANCELLATION_TOKEN,
    payload: {
      formName,
      fieldName,
      token,
      imageId
    }
  };
}

export function setImageUploadStatus(formName, fieldName, status, imageId, isRetry = false) {
  return {
    type: SET_IMAGE_UPLOAD_STATUS,
    payload: {
      formName,
      fieldName,
      status,
      imageId,
      isRetry
    }
  };
}

export function removeCancellationToken(formName, fieldName, imageId){
  return {
    type: REMOVE_CANCELLATION_TOKEN,
    payload: {
      formName,
      fieldName,
      imageId
    }
  };
}



export function setEqpIotDataError(err) {
  return function (dispatch) {
    dispatch({
      type: EQUIPMENT_IOT_DATA_ERROR, 
      payload: err
    });
  }
}

export function fetchEquipmentIOTData(KEN) {
  return function (dispatch) {
    dispatch({type: EQUIPMENT_IOT_DATA_LOADING});
    return axios
      .get(base_path + `/api/masterdata/${KEN}`)
      .then((res) => {
        var equipment = res.data.find((equ) => {
          return equ.equipment.EquipmentNumberKENformatted == KEN;
        });
        dispatch({
          type: EQUIPMENT_IOT_DATA_RECEIVED,
          payload: equipment,
        });
        return {
          ok: true,
          equipment,
        };
      })
      .catch(function (err) {
        const status = err.response && err.response.status ? err.response.status : 500;
        dispatch({
          type: EQUIPMENT_IOT_DATA_ERROR,
          payload: status,
        });
        return {
          ok: false,
          status,
        };
      });
  };
}

function uploadPlannerSurveyImages(formName, imageData, KEN, surveyID, pdmSurveyId, retry) {
  return function (dispatch, getState) {
    let returnResolve;
    const returnPromise = new Promise((resolve) => {
      returnResolve = resolve;
    });

    const uploadToServer = (base64) => {
      let {
        name = 'existing-image.jpg',
        showInPdf = false,
        componentName = '',
        imageId,
        isExistingImage = false,
        key: imageKey,
        pdmAttachmentId = '',
        fileUrl = null,
        id = 0,
      } = base64 ? (imageData || {}) : (imageData?.file || {});

      const attachmentId = id;
      let originalFileName = '';
      if (imageData?.file && imageData.file.name) {
        originalFileName = imageData.file.name;
        name = imageData.file.name;
      }
      if (fileUrl) {
        originalFileName = fileUrl.split('/').pop().split('?')[0];
      }

      const fileData = {
        file: base64, // will be null for existing images
        fileName: name,
        KEN,
        showInPdf,
        componentName,
        surveyID,
        pdmSurveyId,
        imageId,
        isExistingImage,
        attachmentId,
        pdmAttachmentId,
        fileUrl,
        originalFileName,
        retry,
      };

      returnResolve(
        axios({
          method: 'put',
          url: base_path + `/api/survey-attachment/` + encodeURIComponent(surveyID),
          data: fileData,
          timeout: 60 * 5 * 1000, // 5 minutes
          cancelToken: new axios.CancelToken((cancel) => {
            dispatch(addCancellationToken(formName, imageKey, cancel, imageId));
          })
        })
          .then((result) => {
            dispatch(removeCancellationToken(formName, imageKey, imageId));
            dispatch(setImageUploadStatus(formName, imageKey, true, imageId, retry));
            return result;
          })
          .catch((err) => {
            dispatch(setImageUploadStatus(formName, imageKey, false, imageId, retry));
            if (err.message !== "REQUEST_CANCELED") {
              dispatch(removeCancellationToken(formName, imageKey, imageId));
              throw err;
            }
          })
      );
    };

    // If it's an existing image, skip file conversion
    if (imageData?.file?.isExistingImage) {
      uploadToServer(null);
      return returnPromise;
    }

    // For new uploads, convert file to base64
    const reader = new FileReader();
    reader.onload = function () {
      const base64 = reader.result.split(',')[1];
      uploadToServer(base64);
    };

    if (imageData) {
      reader.readAsDataURL(imageData?.file);
    } else {
      console.error("Unsupported file format for upload:", imageData.file);
      returnResolve(Promise.reject(new Error("Unsupported file format")));
    }

    return returnPromise;
  };
}

export function uploadSiteSurveyImages(imageFiles, KEN, surveyID, pdmSurveyId, retry) {
  return async function (dispatch) {
    const failedImages = [];
 
    for (const image of imageFiles) {
      try {
        await dispatch(
          uploadPlannerSurveyImages("siteSurvey", image, KEN, surveyID, pdmSurveyId, retry)
        );
      } catch (error) {
        failedImages.push({
          ...image,
          error: error.message || error,
        });
      }
    }
 
    if (failedImages.length > 0) {
      return {
        success: false,
        failedImages,
      };
    } else {
      return {
        success: true,
        message: "All images uploaded successfully",
      };
    }
  };
}
 

export function submitSiteSurvey(data, ken, formState, checkboxes, plannerLeads) {
  return function(dispatch, getState) {

    /* Hard copy */
    var formData = JSON.parse(JSON.stringify(data));
    const newFormState = lodash.cloneDeep(formState)
    let newCheckboxes = JSON.parse(JSON.stringify(checkboxes));
    let newPlannerLeads = JSON.parse(JSON.stringify(plannerLeads));

    /* Map form fields to IoT data attribute names */
    let iotData = {};
    for (var field in formData) {
      addToExternalData(iotData, field, formData[field]);
    }

    // Map planner leads to payload
    if(Object.keys(newPlannerLeads).length !== 0 && newPlannerLeads.constructor === Object){
      const createMaterials = (materials) => {
        let newList = []
        materials.forEach(item => {
            newList.push({
                PlateMaterial: item.name,
                MaterialQuantity: Number(item.quantity)
            })
        });
        return newList
      }
    
      const createPsrs = (materials) => {
        let newList = []
        materials.forEach(item => {
            newList.push({
              PSRpackage: item.name,
              PSRpackageQuantity: Number(item.quantity)
            })
        });
        return newList
      }
    
      iotData["additionalQuestions"] = []
      for (const [key, value] of Object.entries(newPlannerLeads)) {
        iotData.additionalQuestions.push({
          selection:key,
          materialLabourHours: value.labourHours || 0,
          AdditionalComments: value.additionalComments || "",
          // remove id's from objects, as those are not accepted by Mulesoft
          materials: createMaterials(value.materials),
          psrPackages: createPsrs(value.psrPackages)
        })
      }
    }

    // Map survey type (ELEVATOR/ESCALATOR)
    const { app } = getState();
    const surveyType = app.siteSurveyForm // "ELEVATOR" / "ESCALATOR"
    iotData.directTypes = surveyType === "ELEVATOR" ? "va_cas" : "va_cas_esc"

    dispatch(updateCollectedData({ siteSurvey: data, storedCheckboxes: 
      newCheckboxes, storedFormState: newFormState, storedPlannerLeads: newPlannerLeads }));

    return axios.put(base_path + `/api/survey-data/${ken}`, iotData)
      .then( response => {
        dispatch(storeSurveyId(response.data.surveyId));
      })
      .catch( err => {
        dispatch(formUploadFailed(true));
        console.error(err);
        throw "KEN update failed"
      });
  }
}

export function submitPlannerSiteSurvey(data, ken, formState, plannerLeads, serviceOrder) {
  return function(dispatch, getState) {
    const { app } = getState();

    var formData = JSON.parse(JSON.stringify(data));
    const newFormState = lodash.cloneDeep(formState);

    formData = mapDetailsForSurveySubmission(data, app.iotData.equipment, plannerLeads, serviceOrder);

    dispatch(updateCollectedData({ siteSurvey: data, storedCheckboxes: 
      {}, storedFormState: newFormState, storedPlannerLeads: plannerLeads }));

    return axios.post(base_path + `/api/survey-data/v2/${ken}`, formData)
      .then( response => {
        dispatch(storeSurveyId({
          surveyId: response.data.data.surveyId,
          pdmSurveyId: response.data.data.pdmSurveyId
        }));
      })
      .catch( err => {
        dispatch(formUploadFailed(true));
        console.error(err);
        throw "Site survey Submission Failed";
      });
  }
}

export function submitSiteSurveyImages(data, collectedData, ken, surveyId, pdmSurveyId, retry) {
  return async function (dispatch) {
    const imageData = [];
    let componentName;

    Object.keys(data).forEach(key => {
      if (data[key].images && data[key].images.length > 0) {
        data[key].images.forEach(image => {
          /* Evaluate here if image is already sent. This might be the case if 
          user retrys sending incase of network failure */
          if (!image) {
            return;
          }
          if (image?.file && image.file?.isExistingImage && image.file?.uploadSuccesfull !== true) {
            image.file.key = key;
            imageData.push(image);
          } else if(image.uploadSuccesfull !== true) {
            image.uploadSuccesfull = undefined;
            image.key = key;
            image.imageId = uuidv4();
            componentName = mapComponentNameToImage(image);
            image.componentName = componentName;
            image.showInPdf = true;
            image.attachmentId = null;
            imageData.push(image);
          }
        });
      }
    });
    
    dispatch(updateCollectedData({ ...collectedData, siteSurvey: data }));

    try {
      const result = await dispatch(uploadSiteSurveyImages(imageData, ken, surveyId, pdmSurveyId, retry));
      dispatch(formUploadFailed(false));
      return result;  //  Return result to the caller
    } catch (err) {
      throw "Update failed";
    }

  }
}



export function cancelImageUpload(formName) {

  return function (dispatch, getState) {

    const { app } = getState();

    const data = app.collectedData[formName]
    Object.keys(data).forEach(key => {
      if (data[key].images) {
        data[key].images.forEach(image => {
          let item = app.collectedData[formName][image.key];
          item?.images.map((img) => {
            if (img.imageId && img.cancel) {
              img.cancel("REQUEST_CANCELED");
            }
          }) 
        });
      }
    });
  };
}

export function resetIOTData() {
  return {
    type: RESET_IOT_DATA
  }
}

/* ----------------------------------------------------------------------------
AUTH
--------------------------------------------------------------------------- */

export function getCsrfToken() {

  return function (dispatch) {
    return axios.get(base_path + `/api/getToken`)
      .then((res) => {
        axios.defaults.headers.common['X-CSRF-TOKEN'] = res.data.token;
        dispatch({
          type: STORE_CSRF_TOKEN,
          payload: res.data
        });
      })
      .catch(function (err) {
        console.error(err)
      });
  }
}

export function logout() {
  return {
    type: LOGOUT,
    payload: axios.get(base_path + '/auth/logout')
  }
}

export function initLoggedIn() {

  return async function (dispatch) {
    try {
      const resp = await axios.get(base_path + `/auth/isLoggedIn`)
      dispatch({
        type: INIT_LOGGED_IN,
        payload: true
      });
    } catch (error) {
      dispatch({
        type: INIT_LOGGED_IN,
        payload: false
      });
    }
  }
}

export function getRoleAllowed() {

  return function (dispatch) {
    return axios.get(base_path + `/role_allowed`)
      .then(response => {
        dispatch({
          type: USER_ROLE_RECEIVED,
          payload: response.data.role
        });
      })
      .catch(err => {
        dispatch({
          type: USER_ROLE_RECEIVED,
          payload: false
        });
      });
  }
}

export function getAllowedCompanies() {

  return function (dispatch) {
    return axios.get(base_path + `/allowed_companies`)
      .then(response => {
        dispatch({
          type: COMPANY_LIST_RECEIVED,
          payload: (typeof response == 'object' && response.data) ? response.data.data : []
        });
      })
      .catch(err => {
        dispatch({
          type: COMPANY_LIST_RECEIVED,
          payload: []
        });
      });
  }
}

/* ----------------------------------------------------------------------------
TRANSLATIONS
--------------------------------------------------------------------------- */

/**
 * Converts a flat object with dot-separated keys into a nested object hierarchy.
 * @param flatObject - The flat object to convert.
 * @returns The nested object.
 */
function convertToNestedObject(flatObject) {
  const nestedObject = {};

  Object.keys(flatObject).forEach(key => {
    const keys = key.split('.');
    let currentLevel = nestedObject;

    keys.forEach((subKey, index) => {
      if (!currentLevel[subKey]) {
        currentLevel[subKey] = {};
      }

      if (index === keys.length - 1) {
        currentLevel[subKey] = flatObject[key];
      } else {
        currentLevel = currentLevel[subKey];
      }
    });
  });

  return nestedObject;
}

export function loadTranslation(lang, loadedLangStrings) {
  if(!lang && loadedLangStrings){
    // Avoid spamming load Translation unecessary if lang is null. Without this happens on every page render.
    return () => {}
  }
  
  const getPreferredLanguage = (lang) => {
    let preferredLanguage = 'en';

    if (lang) {
      preferredLanguage = lang;
    } else if (localStorage.getItem('preferredLanguage')) {
      preferredLanguage = localStorage.getItem('preferredLanguage')
    } else if (navigator.language || navigator.userLanguage) {
      preferredLanguage = (navigator.language) ? navigator.language : navigator.userLanguage
    }
    return preferredLanguage
  }

  const language = getPreferredLanguage(lang); // .replace(/[^a-zA-Z0-9_-]/g, '').substring(0, 2)
  
  return function (dispatch) {
    return axios.get(`https://translate.kone.com/api_kts_loader/application/24_7_PSS/${language}/dictionary?EnglishFallback=true&released=false`)
      .then((res) => {          
          setTranslation(dispatch, language, res.data);
          if (Object.keys(res.data).length === 0) {
            console.warn('translation keys are empty for the language from the translation tool: ' + language);
            const translation = require('./translations/' + language + '.json');
            setTranslation(dispatch, language, translation);
          }
      })
      .catch(function (err) {
        console.error('translation load failure for the language ' + language);
        const translation = require('./translations/' + language + '.json');
        setTranslation(dispatch, language, translation);      
      });
  }
};

function setTranslation(dispatch, language, loadedLangStrings) {
  const nestedObject = convertToNestedObject(loadedLangStrings);
  dispatch({
    type: CHANGE_LANGUAGE,
    payload: {
      lang: language,
      trans: nestedObject
    }
  });
}

export function loadLangList() {
  return function (dispatch){
    return axios.get('https://translate.kone.com/api_kts_loader/languages?applicationId=24_7_PSS')
      .then((res) => {
          setLanguage(dispatch, res.data);
          if (res.data.length === 0) {
            console.warn('language array is empty from the translation tool');
            const languages = require('./translations/language-list.json');
            setLanguage(dispatch, languages);
          }
        })
      .catch(function (err) {
        console.error('launguage list load failure');
        const languages = require('./translations/language-list.json');
        setLanguage(dispatch, languages);
      });
  }
};

function setLanguage(dispatch, languageList) {
  // Convert the array to the desired object format
  const convertedResponse = languageList.reduce((acc, curr) => {
    acc[curr.key || curr.id] = curr.name;
    return acc;
  }, {});
  dispatch({
    type: LIST_LANGUAGES,
    payload: convertedResponse
  });
}

/* ----------------------------------------------------------------------------
PROGRESS
--------------------------------------------------------------------------- */
export function addActivePage(title) {
  return {
    type: ADD_ACTIVE_PAGE,
    payload: title
  }
}

export function addFlow(flow){
  return {
    type: ADD_FLOW,
    payload: flow
  }
}

/* ----------------------------------------------------------------------------
ENV
--------------------------------------------------------------------------- */
export function getApplicationEnvironment() {

  return function (dispatch) {
    return axios.get(base_path + `/api/env`)
      .then(response => {
        dispatch({
          type: RECEIVE_APP_PROPS,
          payload: response.data
        });
      })
      .catch(err => {
        dispatch({
          type: RECEIVE_APP_PROPS,
          payload: {
            classicProvisioning: "ERROR"
          }
        });
      });
  }
}

export function fetchSurveyData(KEN) {
  return function (dispatch) {
    dispatch({type: PREVIOUS_SITE_SURVEY_DATA_LOADING});
    return axios.get(base_path + `/api/get-survey/${KEN}`)
      .then((res) => {
        if (res?.data?.data) {
          dispatch({
            type: PREVIOUS_SITE_SURVEY_DATA_RECEIVED,
            payload: res.data.data
          });
        }
      })
      .catch(function (err) {
        if (err.response.status === 502) {
          //to handle server timeout
          dispatch({
            type: PREVIOUS_SITE_SURVEY_DATA_ERROR,
            payload: err.response.status,
          });
        } else {
          dispatch({
            type: PREVIOUS_SITE_SURVEY_DATA_ERROR,
            payload:
              err.response && err.response.status ? err.response.status : 500,
          }); 
        }
      });
    }
}
